import download from "downloadjs";
import ExcelJS from "exceljs";
import { Button } from "../ui/button";

const criarEstruturaHierarquica = (data) => {
  return data.reduce((acc, entry) => {
    let usuario = acc.find((u) => u.membro === entry.usuario_colaborador);

    if (!usuario) {
      usuario = { membro: entry.usuario_colaborador, projetos: [] };
      acc.push(usuario);
    }

    let projeto = usuario.projetos.find((p) => p.nome === entry.nome_projeto);

    if (!projeto) {
      projeto = { nome: entry.nome_projeto || "", epicos: [] };
      usuario.projetos.push(projeto);
    }

    const nomeEpico = entry.nome_epico || "";
    let epico = projeto.epicos.find((e) => e.nome === nomeEpico);

    if (!epico) {
      epico = {
        nome: nomeEpico,
        horas: entry.epico_horas,
        atividades: entry.historias_de_usuario || [],
      };
      projeto.epicos.push(epico);
    }

    return acc;
  }, []);
};

const estilosPadrao = {
  font: { name: "Arial", size: 10 },
  alignment: { vertical: "middle", horizontal: "center", wrapText: true },
  border: {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" },
  },
};

const estiloCabecalho = {
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FF000000" } },
  font: { color: { argb: "FFFFFFFF" }, bold: true },
};

const estiloIncompleto = {
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFD5BE" } },
  font: { color: { argb: "FFEB8825" }, bold: true },
  border: {
    top: { style: "thin", color: { argb: "FFEB8825" } },
    left: { style: "thin", color: { argb: "FFEB8825" } },
    bottom: { style: "thin", color: { argb: "FFEB8825" } },
    right: { style: "thin", color: { argb: "FFEB8825" } },
  },
};

const estiloProdutivo = {
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFF0FDF4" } },
  font: { color: { argb: "FF047857" }, bold: true },
  border: {
    top: { style: "thin", color: { argb: "FF10B981" } },
    left: { style: "thin", color: { argb: "FF10B981" } },
    bottom: { style: "thin", color: { argb: "FF10B981" } },
    right: { style: "thin", color: { argb: "FF10B981" } },
  },
};

const estiloOk = {
  fill: { type: "pattern", pattern: "solid", fgColor: { argb: "FFBFDBFE" } },
  font: { color: { argb: "FF2563EB" }, bold: true },
  border: {
    top: { style: "thin", color: { argb: "FF60A5FA" } },
    left: { style: "thin", color: { argb: "FF60A5FA" } },
    bottom: { style: "thin", color: { argb: "FF60A5FA" } },
    right: { style: "thin", color: { argb: "FF60A5FA" } },
  },
};

export default function DownloadExcel({ data, fileName }) {
  const handleClick = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Relatório");

    // Configurar colunas
    worksheet.columns = [
      { header: "Membro", key: "membro", width: 25 },
      { header: "Projeto", key: "projeto", width: 25 },
      { header: "Épico", key: "epico", width: 25 },
      { header: "Horas Épico", key: "horas_epico", width: 15 },
      { header: "Atividade", key: "atividade", width: 35 },
      { header: "Início", key: "inicio", width: 15 },
      { header: "Fim", key: "fim", width: 15 },
      { header: "Estimado", key: "estimado", width: 15 },
      { header: "Realizado", key: "realizado", width: 15 },
      { header: "Status", key: "status", width: 15 },
    ];

    // Adicionar dados
    const estrutura = criarEstruturaHierarquica(data);
    let rowIndex = 2;

    estrutura.forEach((usuario) => {
      const startRow = rowIndex;

      usuario.projetos.forEach((projeto) => {
        const projetoStart = rowIndex;

        projeto.epicos.forEach((epico) => {
          const epicoStart = rowIndex;

          epico.atividades.forEach((atividade) => {
            worksheet.addRow({
              membro: usuario.membro,
              projeto: projeto.nome,
              epico: epico.nome,
              horas_epico: epico.horas,
              atividade: atividade.titulo_hu,
              inicio: atividade.data_inicio,
              fim: atividade.data_fim,
              estimado: atividade.tempo_esperado,
              realizado: atividade.tempo_gasto,
            });

            // Adicionar fórmula para Status
            worksheet.getCell(`J${rowIndex}`).value = {
              formula: `IF(OR(C${epicoStart}="", D${epicoStart}="", F${rowIndex}="", G${rowIndex}="", H${rowIndex}="", I${rowIndex}=""), 
                "INCOMPLETO", 
                IF(H${rowIndex} > I${rowIndex}, 
                  IF(H${rowIndex} <= D${epicoStart}, "PRODUTIVO", "OK"), 
                  "OK"
                )
              )`,
            };

            rowIndex++;
          });

          // Adicionar total do épico
          if (epico.atividades.length > 0) {
            worksheet.addRow({
              epico: "TOTAL",
              estimado: { formula: `SUM(H${epicoStart}:H${rowIndex - 1})` },
              realizado: { formula: `SUM(I${epicoStart}:I${rowIndex - 1})` },
            });

            // Adicionar fórmula para Status do total
            worksheet.getCell(`J${rowIndex}`).value = {
              formula: `IF(SUMPRODUCT(--(J${epicoStart}:J${rowIndex - 1}="INCOMPLETO")) > 0, 
                "INCOMPLETO", 
                IF(H${rowIndex} > I${rowIndex}, 
                  IF(H${rowIndex} <= D${epicoStart}, "PRODUTIVO", "OK"), 
                  "OK"
                )
              )`,
            };
            

            // Mesclar células de total
            worksheet.mergeCells(`C${rowIndex}:G${rowIndex}`);

            // Mesclar células do épico
            worksheet.mergeCells(`C${epicoStart}:C${rowIndex - 1}`);

            //Mesclar células de horas do épico
            worksheet.mergeCells(`D${epicoStart}:D${rowIndex - 1}`);

            rowIndex++;
          }
        });

        // Mesclar células do projeto
        if (projeto.epicos.length > 0) {
          worksheet.mergeCells(`B${projetoStart}:B${rowIndex - 1}`);
        }
      });

      // Mesclar células do membro
      if (usuario.projetos.length > 0) {
        worksheet.mergeCells(`A${startRow}:A${rowIndex - 1}`);
      }
    });

    // Adicionar formatação condicional para Status
    // Regra para INCOMPLETO
    worksheet.addConditionalFormatting({
      ref: `J2:J${rowIndex - 1}`,
      rules: [
        {
          type: "expression",
          formulae: [`J2="INCOMPLETO"`],
          style: estiloIncompleto,
        },
      ],
    });

    // Regra para OK
    worksheet.addConditionalFormatting({
      ref: `J2:J${rowIndex - 1}`,
      rules: [
        {
          type: "expression",
          formulae: [`J2="OK"`],
          style: estiloOk,
        },
      ],
    });

    // Regra para PRODUTIVO
    worksheet.addConditionalFormatting({
      ref: `J2:J${rowIndex - 1}`,
      rules: [
        {
          type: "expression",
          formulae: [`J2="PRODUTIVO"`],
          style: estiloProdutivo,
        },
      ],
    });

    // Aplicar estilos
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell({ includeEmpty: true }, (cell) => {
        Object.assign(cell.style, estilosPadrao);

        // Aplicar quebra de texto específica
        if ([2, 5].includes(cell.col)) {
          // Colunas B (Projeto) e E (Atividade)
          cell.alignment = { ...cell.alignment, wrapText: true };
        }

        if (rowNumber === 1 || cell.value === "TOTAL") {
          Object.assign(cell.style, estiloCabecalho);
        }
      });
    });

    // Gerar e baixar arquivo
    const buffer = await workbook.xlsx.writeBuffer();
    download(
      new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      `${fileName || "relatorio"}.xlsx`
    );
  };

  return (
    <Button
      onClick={handleClick}
      className="bg-gray-800 hover:bg-gray-700 text-white gap-2 items-center"
      size="lg"
    >
      Baixar Tabela
    </Button>
  );
}
